// ABOUTME: Content header for the detail panel — shows scope name, parent link, and status pill.
// ABOUTME: Uses CardHeader from @hm/fundamental with aside for status pill and reset button.
import {Button, CardHeader, Pill, Icon, LabelMedium} from '@hm/fundamental'
import {mdiReload} from '@mdi/js'
import React from 'react'

import {CountryConfigsTooltip} from './CountryConfigsTooltip'
import {useTranslation} from '../../../../hooks/useTranslation'
import {EntityContentHeaderProps} from '../types'

export const EntityContentHeader: React.FC<EntityContentHeaderProps> = ({
  scopeTitle,
  parent,
  valuesStatus,
  onReset,
  isLoading,
  scopeIcon,
  scopeIconClassName,
  actions
}) => {
  const {t} = useTranslation()

  if (isLoading) {
    return (
      <div className="shrink-0 p-4 border-b border-border">
        <div className="flex items-center px-2 min-h-[48px]">
          <div className="flex items-center gap-2">
            <div className="h-6 w-6 rounded bg-border animate-pulse shrink-0" />
            <div className="h-6 w-[200px] rounded bg-border animate-pulse" />
          </div>
        </div>
      </div>
    )
  }

  const aside = (
    <div className="flex items-center gap-3">
      {valuesStatus === 'overridden' && (
        <>
          <Pill
            type="info"
            text={t('countryConfigurations.entity.header.overriddenValues')}
            className="pointer-events-none"
          />
          {onReset && (
            <CountryConfigsTooltip content={t('countryConfigurations.entity.header.resetTooltip')} tooltipClassName="whitespace-nowrap">
              <Button
                variant="secondary"
                type="button"
                square
                onClick={onReset}
                aria-label={t('countryConfigurations.entity.header.resetAriaLabel')}
              >
                <Icon path={mdiReload} size="regular" />
              </Button>
            </CountryConfigsTooltip>
          )}
        </>
      )}
      {valuesStatus === 'allInherited' && (
        <Pill
          type="neutral"
          text={t('countryConfigurations.entity.header.allInherited')}
          className="pointer-events-none"
        />
      )}
      {actions}
    </div>
  )

  return (
    <div className="shrink-0 p-4 border-b border-border">
      <div className="px-2">
        <CardHeader
          aside={aside}
          containerClassname="!mb-0 min-h-[48px]"
        >
          <span className="flex items-center gap-2">
            {scopeIcon && (
              <Icon path={scopeIcon} size="regular" className={scopeIconClassName} />
            )}
            {scopeTitle}
          </span>
        </CardHeader>
        {parent && (
          <LabelMedium className="text-foreground_faded mt-1">
            {t('countryConfigurations.entity.header.parent')}{' '}
            <button
              type="button"
              onClick={parent.onClick}
              className="text-primary underline hover:text-primary_hover cursor-pointer bg-transparent border-none p-0 font-inherit text-inherit"
            >
              {parent.label}
            </button>
          </LabelMedium>
        )}
      </div>
    </div>
  )
}
